module.exports = "<ul>\n  <li *ngFor=\"let item of navItems\">\n    <a\n      routerLink=\"{{item.href}}\"\n      [ngClass]=\"\n        url.includes(item.href)\n        || (item.href === '/experiences' && (url.includes('partner') || url === '/'))\n        ? 'active' : ''\n      \"\n    >\n      {{item.label}}\n    </a>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/navigation/navigation.component.html
// module id = ./src/app/header/navigation/navigation.component.html
// module chunks = main